import { autoinject } from 'aurelia-framework';
import { NotificationModel } from "./notification-model";
import { remove } from "lodash";
import { ResourceService } from "../../utils/resourceService";

export class NotificationService {
	notifications: NotificationModel[];

	constructor() {
		this.notifications = [];
	}

	private expireNotification(notification): void {
		remove(this.notifications, notification);
	}

	add(title: string, content: string = null, type: NotificationType = null, hideAfterMs: number = 10000, onDismiss: Function = this.expireNotification.bind(this)): NotificationModel {
		const notification = new NotificationModel(title, content, type, hideAfterMs, onDismiss);
		this.notifications.push(notification);
		return notification;
	}

	push(title: string, content: string = null, type: NotificationType = null, hideAfterMs: number = 10000): void {
		this.add(title, content, type, hideAfterMs).show();
	}
}

@autoinject
export class ResourcedNotificationService {
	constructor(private notificationService: NotificationService, private resourceService: ResourceService) {
	}

	push(titleResource: string,
		type: NotificationType,
		contentResource: string = null,
		titleParams: any[] = null,
		contentParams: any[] = null) {

		const title = this.resourceService.getResource(titleResource, titleParams);
		const content = contentResource ? this.resourceService.getResource(contentResource, contentParams) : null;

		this.notificationService.push(title, content, type);
	}

	pushWithLiteralContent(titleResource: string,
		type: NotificationType,
		content: any,
		titleParams: any[] = null) {

		const contentString: string =
			typeof content === "string" ? content : Object.keys(content).map(k => `${k}: ${content[k]}`).join('; ');

		const title = this.resourceService.getResource(titleResource, titleParams);

		this.notificationService.push(title, contentString, type);
	}
}

export enum NotificationType {
	Success, StickySuccess, Error, Warning, Info
}

export enum NotificationState {
	Hidden, Show
}
